module.exports = __webpack_public_path__ + "static/ninth-house-5dc32c1a15676f0bee093aaac54b3cde.jpg";